
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableTabMobileRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabMobileRT(): TemplateResult<fitmentTableTabMobileRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('div', { 'key': '0' }, _createElement('span', { 'className': 'text' }, 'Fitment'), _createElement('span', { 'className': 'icon-plus' }, ' ')) : null;
}
        export const componentNames = []